export const ACTION_TYPES = Object.freeze({
  APP_TASK_SET: "APP_TASK_SET",
  APP_ERROR_PUSH: "APP_ERROR_PUSH",
  APP_ERROR_DISMISS: "APP_ERROR_DISMISS",
})

export const initialState = {
  taskArray: [],
  errors: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.APP_TASK_SET:
      let newlist = []
      if (action.taskArray) {
        newlist = state.taskArray
        newlist.push(action.taskArray)
      }
      return {
        ...state,
        taskArray: newlist,
      }
    case ACTION_TYPES.APP_ERROR_PUSH:
      return {
        ...state,
        errors: [...state.errors, action.error],
      }
    case ACTION_TYPES.APP_ERROR_DISMISS:
      return {
        ...state,
        errors: state.errors.filter((e) => e.id !== action.id),
      }
    case "LOGOUT":
      return {
        ...initialState,
      }
    default: {
      return state
    }
  }
}
